module.exports = __webpack_public_path__ + "img/industria-1.8a969e98.png";